import * as THREE from 'three';
import { TrackElement } from './TrackElement';
import { TrainingTrackElement } from '../../../../../shared/src/trainingTrack.types';

/**
 * Class representing an obstacle element in the training track
 */
export class ObstacleElement extends TrackElement {
    private obstacleMesh: THREE.Mesh | null = null;
    
    /**
     * Constructor
     * @param element The obstacle element data
     */
    constructor(element: TrainingTrackElement) {
        super(element);
    }
    
    /**
     * Creates the Three.js object for this obstacle
     * @returns The created obstacle object
     */
    protected createObject(): THREE.Object3D {
        // Create a simple obstacle using a box geometry
        const geometry = new THREE.BoxGeometry(1, 1, 1);
        const material = new THREE.MeshStandardMaterial({ color: 0x8B4513 }); // Brown color
        
        this.obstacleMesh = new THREE.Mesh(geometry, material);
        this.obstacleMesh.scale.set(this.element.scale, this.element.scale * 2, this.element.scale);
        this.obstacleMesh.castShadow = true;
        this.obstacleMesh.receiveShadow = true;
        
        // Adjust position to account for obstacle height
        this.obstacleMesh.position.y = this.element.scale;
        
        return this.obstacleMesh;
    }
    
    /**
     * Handles player interaction with this obstacle
     * @param playerPosition The player's position
     * @param playerTank The player's tank
     * @param distance The distance to the player
     * @returns True if interaction was handled, false otherwise
     */
    public handleInteraction(playerPosition: THREE.Vector3, playerTank: any, distance: number): boolean {
        // Obstacles don't have special interactions, they just block the player
        return false;
    }
}